
import classnames from "classnames";

const GUIDE_STEPS = [
    {
        id         : "onboard-brand",
        title      : "Onboard a brand",
        description: "Go to Onboard brand and complete the form — brand name, platform, KYC window and notification settings. Publishers are invited automatically once the brand is created."
    },
    {
        id         : "brand-kyc",
        title      : "Move brand KYC",
        description: "Open a brand, go to the KYC tab, upload their documents and move the status to Verified. A brand must be verified before you can generate a debit note."
    },
    {
        id         : "publisher-kyc",
        title      : "Review publisher KYC",
        description: "Open the Publishers tab on any brand and use the KYC drawer to see verification results, failure reasons and submission history for each publisher."
    },
    {
        id         : "debit-note",
        title      : "Raise & send debit note",
        description: "On the brand's Debit notes tab, generate the draft, check each line item, then confirm it. The brand is notified and sees it on their portal."
    },
    {
        id         : "approval",
        title      : "Wait for acknowledgement & approval",
        description: "The brand acknowledges receipt, then approves the note and pays offline. Both timestamps show against the note."
    },
    {
        id         : "funds-received",
        title      : "Confirm funds received",
        description: "Once the transfer lands, open the debit note and mark funds received. This unlocks the disbursement queue for that brand."
    },
    {
        id         : "disburse",
        title      : "Disburse to publishers",
        description: "In Disbursements — or inline from the Publishers list — record the UTR reference and payment date for each KYC-verified publisher. They are notified automatically."
    }
];

const UserGuide = () => {

    return (
        <div className="p-6">
            <div className="flex items-start justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight">Ops user guide</h1>
                    <p className="mt-1 text-sm text-muted">Run the payouts desk end to end.</p>
                </div>
            </div>

            <div className="mt-6 space-y-3">
                {GUIDE_STEPS.map((step, idx) => {
                    return (
                        <div
                            key={step.id}
                            className={classnames(
                                "flex items-start gap-4 rounded-xl border bg-white p-5 shadow-sm transition-colors border-gray-200"
                            )}>
                            <div>
                                <p className="text-xs font-semibold uppercase tracking-wide text-accent">Step {idx + 1}</p>
                                <p className={classnames("mt-0.5 text-base font-semibold text-gray-900")}>
                                    {step.title}
                                </p>
                                <p className="mt-1 text-sm text-muted">{step.description}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default UserGuide;
